import { Box, Button, Grid, Typography } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import useAPI from "../../../../../api/hooks/useAPI";
import useColors from "../../../../../api/hooks/useColors";
import { tagKeys } from "../../../../../api/queryKeys";
import CustomToolTip from "../../../../../components/CustomTooltip";
import SvgToIcon from "../../../../../icons/SvgToIcon";
import { useEntities } from "../../hooks/useEntities";
import { icons } from "../../icons/iconExport";
import TagChipWithDropDown from "../TagsDropDown/TagChipWithDropDown";
import TagsDropdown from "../TagsDropDown/TagsDropdown";

const TagsListSection = ({ selectedEntity }) => {
  const { getAllCustomTags } = useAPI();
  const { useQueryForEntitiesByType } = useEntities();

  const tagsQuery = useQuery({
    queryKey: tagKeys.all,
    queryFn: getAllCustomTags,
    select: (data) => data.data,
  });

  const entitiesQuery = useQueryForEntitiesByType({
    type: selectedEntity?.entity_type,
    enabled: Boolean(selectedEntity?.entity_type),
  });

  const tagIdToKeyValueMap =
    tagsQuery.data
      ?.filter((tag) => !tag.is_deleted)
      .reduce((acc, tag) => {
        acc[tag.tag_id] = {
          key: tag.key,
          value: tag.value,
        };
        return acc;
      }, {}) || {};

  const entities = entitiesQuery.data || [];
  const cachedEntity = Array.isArray(entities)
    ? entities.find((e) => e.entity_id === selectedEntity?.entity_id)
    : null;
  const currentEntity = cachedEntity || selectedEntity;

  const entityTags = currentEntity?.custom_tags || [];
  const validTags =
    entityTags
      .map((tagId) => ({
        tagId,
        ...tagIdToKeyValueMap[tagId],
      }))
      .filter((tag) => tag.key !== undefined) || [];

  const [menuAnchorEl, setMenuAnchorEl] = useState(null);
  const colors = useColors();
  return (
    <Grid
      item
      xs={12}
      display={"flex"}
      flexDirection={"column"}
      gap={"12px"}
      mt={"8px"}
    >
      <Box
        display={"flex"}
        flexDirection={"row"}
        gap={"10px"}
        alignItems={"center"}
      >
        <Typography variant="subtitle1">Tags</Typography>
      </Box>
      <Box display={"flex"} flexDirection={"column"} gap={1}>
        <Box
          display={"flex"}
          flexDirection={"row"}
          gap={1}
          flexWrap={"wrap"}
          alignItems={"center"}
        >
          {validTags.map((tag) => (
            <TagChipWithDropDown
              key={tag.tagId}
              tagKey={tag.key}
              tagValue={tag.value}
              entities={[currentEntity]}
            />
          ))}
          <CustomToolTip
            title={validTags.length > 0 ? "Add a tag" : null}
            placement="top"
          >
            <Button
              sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                gap: "8px",
                padding: "2px 4px",
                borderRadius: "2px",
                textTransform: "none",
                whiteSpace: "nowrap",
                color: colors.text_secondary,
              }}
              onClick={(event) => setMenuAnchorEl(event.currentTarget)}
            >
              <SvgToIcon
                IconLogo={icons.AddIcon}
                style={{
                  width: "18px",
                  height: "18px",
                }}
              />
              {validTags.length === 0 && (
                <Typography variant="caption">Add a tag</Typography>
              )}
            </Button>
          </CustomToolTip>
        </Box>
        {menuAnchorEl && (
          <TagsDropdown
            selectedEntities={[currentEntity]}
            menuAnchorEl={menuAnchorEl}
            setMenuAnchorEl={setMenuAnchorEl}
          />
        )}
      </Box>
    </Grid>
  );
};

export default TagsListSection;
